module.exports = __webpack_public_path__ + "img/img-paddock.eb16c097.png";